import { render } from "./LayersManagementFilterTab.vue?vue&type=template&id=6b4e1916&scoped=true&ts=true"
import script from "./LayersManagementFilterTab.vue?vue&type=script&lang=ts"
export * from "./LayersManagementFilterTab.vue?vue&type=script&lang=ts"

import "./LayersManagementFilterTab.vue?vue&type=style&index=0&id=6b4e1916&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4e1916"]])

export default __exports__